const features = [
  {
    id: 'browse',
    eyebrow: '浏览',
    title: '打开网页更快，标签切换不等待',
    desc: '首页直达、内核精简，常用站点点开即见，来回切换标签也不再有明显的停顿感，碎片时间也能随手刷完。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20visualization%20of%20fast%20lightweight%20web%20browsing%2C%20translucent%20glass%20layers%20and%20swift%20motion%20lines%20over%20a%20soft%20warm%20cream%20background%2C%20minimal%20geometric%20composition%2C%20warm%20amber%20and%20cream%20palette%2C%20editorial%20technology%20illustration%2C%20soft%20shadows%2C%20clean%20and%20airy%2C%20no%20text&width=900&height=640&seq=91br-feature-browse&orientation=landscape',
    reverse: false,
  },
  {
    id: 'play',
    eyebrow: '播放',
    title: '看片更稳，清晰度随手切换',
    desc: '视频页减少多余跳转，加载更快、拖动更跟手，遇到网络起伏也能自动降档续播，尽量不让画面卡在半路。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20of%20smooth%20high%20definition%20video%20playback%20on%20a%20mobile%20screen%2C%20soft%20glowing%20frame%20with%20flowing%20color%20ribbons%2C%20gentle%20green%20and%20warm%20amber%20gradient%20background%2C%20minimal%20geometric%20composition%2C%20editorial%20technology%20visual%2C%20soothing%20and%20clean%2C%20no%20text&width=900&height=640&seq=91br-feature-play&orientation=landscape',
    reverse: true,
  },
  {
    id: 'memory',
    eyebrow: '内存',
    title: '占用更省，内存小也顺滑',
    desc: '后台做减法的同时把常驻开销压下来，小内存机型也能多开几个标签，长时间使用不容易发烫、掉速。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20stylized%20illustration%20representing%20efficient%20memory%20usage%2C%20layered%20floating%20cards%20and%20tidy%20stacking%20blocks%20on%20a%20light%20warm%20neutral%20background%2C%20minimal%20geometric%20composition%2C%20calm%20amber%20accent%2C%20editorial%20technology%20visual%2C%20clean%20airy%20layout%2C%20no%20text&width=900&height=640&seq=91br-feature-memory&orientation=landscape',
    reverse: false,
  },
];

export default function FeatureFlow() {
  return (
    <section id="experience" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="max-w-2xl reveal reveal-1">
          <span className="text-xs md:text-sm font-medium text-accent-700 tracking-wide">
            使用体验
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            日常那点别扭，逐条理顺
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            不堆参数，只聊你真正会遇到的三件事：打开慢、看着卡、内存紧。
          </p>
        </div>

        <div className="mt-12 md:mt-16 flex flex-col gap-12 md:gap-20">
          {features.map((f) => (
            <article
              key={f.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14 items-center reveal reveal-2 ${
                f.reverse ? 'lg:[&>figure]:order-2' : ''
              }`}
            >
              <figure className="w-full">
                <div className="w-full aspect-[3/2] rounded-lg overflow-hidden bg-background-100 border border-background-200">
                  <img
                    src={f.img}
                    alt={`91浏览器手机版 - ${f.title}`}
                    title={`91浏览器 ${f.eyebrow} 体验`}
                    className="w-full h-full object-top"
                  />
                </div>
              </figure>

              <div>
                <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
                  <i className="ri-circle-fill text-[6px]"></i>
                  {f.eyebrow}
                </span>
                <h3 className="mt-4 font-heading font-bold text-xl md:text-3xl text-foreground-950 leading-snug">
                  {f.title}
                </h3>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {f.desc}
                </p>
                <a
                  href="#download"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
                >
                  下载安卓版体验
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}